__turbopack_context__.v({
  "dropdown": "_9fJSJa_dropdown",
  "dropdown__input": "_9fJSJa_dropdown__input",
  "dropdown__input__icon": "_9fJSJa_dropdown__input__icon",
  "dropdown__input__text": "_9fJSJa_dropdown__input__text",
  "dropdown__options": "_9fJSJa_dropdown__options",
  "dropdown__options__list": "_9fJSJa_dropdown__options__list",
  "dropdown__options__list__option": "_9fJSJa_dropdown__options__list__option",
  "dropdown__options__search": "_9fJSJa_dropdown__options__search",
  "wrapper": "_9fJSJa_wrapper",
});
